/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (Openapi Generator)
 */

import { exists } from '../runtime';
/**
 * 
 * @export
 * @interface SimilarRequestObjectionVariant
 */
export interface SimilarRequestObjectionVariant {
    /**
     * 
     * @type {number}
     * @memberof SimilarRequestObjectionVariant
     */
    objectionVariantId?: number;
    /**
     * 
     * @type {number}
     * @memberof SimilarRequestObjectionVariant
     */
    position?: number;
}

export function SimilarRequestObjectionVariantFromJSON(json: any): SimilarRequestObjectionVariant {
    return SimilarRequestObjectionVariantFromJSONTyped(json, false);
}

export function SimilarRequestObjectionVariantFromJSONTyped(json: any, ignoreDiscriminator: boolean): SimilarRequestObjectionVariant {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'objectionVariantId': !exists(json, 'objectionVariantId') ? undefined : json['objectionVariantId'],
        'position': !exists(json, 'position') ? undefined : json['position'],
    };
}

export function SimilarRequestObjectionVariantToJSON(value?: SimilarRequestObjectionVariant | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'objectionVariantId': value.objectionVariantId,
        'position': value.position,
    };
}

